"use client";

import React from "react";
import "@amzn/rigel-pattern-footer/dist/styles/bundle.css";
import FooterTemplate from "@amzn/rigel-pattern-footer";
import {
  useCookiePreferences,
  usePrivacyPreferences,
} from "@/lib/hooks/useCookie";
import {
  availableLanguages,
  languageToLocaleMap,
  localesMap,
} from "@/lib/constants/i18n";
import { useRouter, usePathname } from "next/navigation";
import { FooterDictionary } from "@/types";
import { createLocalizedPath } from "@/lib/utils/utils";
import { Locale } from "@/types/awsm";
import { convertToLocale } from "@/lib/utils/localeUtils";

const Footer = ({
  dictionary,
  language,
}: {
  dictionary: FooterDictionary;
  language: string;
}) => {
  const router = useRouter();
  const pathname = usePathname();

  const showCookiePreferences = useCookiePreferences();
  const { show: showPrivacyPreferences } = usePrivacyPreferences();

  return (
    <div className="awsm pt-20 z-0">
      <FooterTemplate
        availableLanguages={availableLanguages as Array<Locale>}
        {...dictionary}
        locale={convertToLocale(languageToLocaleMap[language])}
        onShowCookiePreferences={() => showCookiePreferences?.()}
        onShowPrivacyPreferences={showPrivacyPreferences}
        onLanguageSelect={(_, language) => {
          router.push(
            createLocalizedPath({
              currentPath: pathname,
              newLocale: localesMap[language.code],
              supportedLocales: Object.values(localesMap),
            }),
          );
        }}
      />
    </div>
  );
};

export default Footer;
